import jwt from 'jsonwebtoken';

/*
 * Reads the premise token that CrmModule `premises/:sprn` returns as `_sessionId`,
 * without checking its signature. The browser used to verify it with a key that
 * had to ship to every visitor, so the check protected nothing and published the
 * key (WEB-1663). What the check did usefully — reject a malformed or expired
 * token — is kept, so every caller's fallback still fires in the same cases.
 */
export const readPremiseToken = (token) => {
  const decoded = jwt.decode(token);
  if (!decoded || typeof decoded !== 'object') throw new Error('Malformed premise token');
  if (typeof decoded.exp === 'number' && Math.floor(Date.now() / 1000) >= decoded.exp) {
    throw new Error('Premise token expired');
  }
  return decoded;
};
